import { render } from "./CryptoNews.vue?vue&type=template&id=7a67c7b4&scoped=true"
import script from "./CryptoNews.vue?vue&type=script&lang=js"
export * from "./CryptoNews.vue?vue&type=script&lang=js"

import "./CryptoNews.vue?vue&type=style&index=0&id=7a67c7b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a67c7b4"]])

export default __exports__